<div id="company-view-list" class="company-view-list">
    <div class="card-view">
        <div class="company-filter">
            <div class="company-search-block">
                <input [(ngModel)]="searchString" autocomplete="off" class="" type="text">
                <button (click)="searchCompany(searchString)" mat-mini-fab color="primary"
                    aria-label="Example icon button with a menu icon">
                    <mat-icon>search</mat-icon>
                </button>
            </div>
            <div class="filter-list">
                <div class="form-wrap select-view">
                    <mat-form-field appearance="fill">
                        <mat-label>Estado de la Empresa</mat-label>
                        <mat-select [(ngModel)]="activeStatusTreeView" (selectionChange)="activeStatusChange(activeStatusTreeView)" >
                            <mat-option value="A">Activas</mat-option>
                            <mat-option value="I">Inactivas</mat-option>
                            <mat-option value="T">Todas</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
        </div>
        <div class="company-tree-view">
            <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
                <mat-tree-node (click)="activeNode = node" [ngClass]="{ 'mat-selectted-node ': activeNode === node,'mat-deactivate': node.status=='N','mat-strike':  node.status=='E','mat-deactivate-contacto': node.finGestion==true}" 
                    (click)="nodeOperationsLoadEmpresa(node)" *matTreeNodeDef="let node" matTreeNodeToggle
                    matTreeNodePadding matTreeNodePaddingIndent="25">
                    <p>{{node.name }}</p>
                    <button (click)="nodeOperations(node)" class="options" mat-icon-button
                        [matMenuTriggerFor]="moreMenu2">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </mat-tree-node>

                <mat-tree-node (click)="activeNode = node" [ngClass]="{ 'mat-selectted-node': activeNode === node,'mat-deactivate': node.status=='N','mat-strike':  node.status=='E','mat-deactivate-contacto': node.finGestion==true}"
                    (click)="nodeOperationsLoadEmpresa(node)" *matTreeNodeDef="let node;when: hasChild"
                    matTreeNodePadding matTreeNodePaddingIndent="15">
                    <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'toggle ' + node.name" (click)="ResetTree(node)">
                        <mat-icon class="mat-icon-rtl-mirror" >
                            {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                        </mat-icon>
                    </button>
                    <p>{{node.name}}</p>

                    <button (click)="nodeOperations(node)" class="options" mat-icon-button
                        [matMenuTriggerFor]="moreMenu2">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </mat-tree-node>
            </mat-tree>


        </div>
    </div>
</div>

<mat-menu #moreMenu2="matMenu" [overlapTrigger]="false">
    <a *ngIf="crearPermission" class="list-contxt-item">
        <button mat-menu-item (click)="createcompany()">
            <!-- <mat-icon>add</mat-icon> -->
            <span>Crear</span>
        </button>
    </a>
    <a *ngIf="activarPermission" class="list-contxt-item">
        <button (click)="activarCompany()" mat-menu-item>
            <!-- <mat-icon>add</mat-icon> -->
            <span>Activar</span>
        </button>
    </a>
     <a class="list-contxt-item">
        <button (click)="descargarWordNivel()" mat-menu-item>
            <!-- <mat-icon>swap_vertical_circle</mat-icon> -->
            <span>Descargar Árbol de Empresa</span>
        </button>
    </a>
    <a *ngIf="desactivarPermission" class="list-contxt-item">
        <button (click)="desactivarCompany()" mat-menu-item>
            <!-- <mat-icon>add</mat-icon> -->
            <span>Desactivar</span>
        </button>
    </a>
    <a *ngIf="moverPermission" class="list-contxt-item">
        <button mat-menu-item (click)="movecompany()">
            <!-- <mat-icon>swap_vertical_circle</mat-icon> -->
            <span>Mover</span>
        </button>
    </a>
    <a *ngIf="cerrarBajasPermission" class="list-contxt-item">
        <button (click)="cerrarBajasCompany()" mat-menu-item>
            <!-- <mat-icon>swap_vertical_circle</mat-icon> -->
            <span>Cerrar bajas</span>
        </button>
    </a>
    <a *ngIf="bloquearPermission" class="list-contxt-item">
        <button (click)="bloquearTrabajadoresCompany()" mat-menu-item>
            <!-- <mat-icon>swap_vertical_circle</mat-icon> -->
            <span>Bloquear trabajadores de baja de empresa</span>
        </button>
    </a>
    <a *ngIf="eliminarDatosPermission" class="list-contxt-item">
        <button (click)="eliminarDatosCompany()" mat-menu-item>
            <!-- <mat-icon>swap_vertical_circle</mat-icon> -->
            <span>Eliminar Datos</span>
        </button>
    </a>
    <a *ngIf="eliminarEmpresaPermission" class="list-contxt-item">
        <button (click)="eliminarCompany()" mat-menu-item>
            <!-- <mat-icon>swap_vertical_circle</mat-icon> -->
            <span>Eliminar Empresa</span>
        </button>
    </a>
</mat-menu>